import Chart from 'chart.js/auto';

export default class ChartJsLoader {
  constructor() {
    this.chartElements = document.querySelectorAll('.js-chart');
    this.loadCharts();
  }

  isChartScriptAvailable() {
    return typeof Chart !== 'undefined';
  }

  loadChartScript() {
    if (!this.isChartScriptAvailable()) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/chart.js';
      script.onload = () => this.initializeCharts();
      document.body.appendChild(script);
    } else {
      this.initializeCharts();
    }
  }

  defaultChartOptions(chart) {
    const labels = chart.labels;
    const data = chart.chartdata;
    const bgColors = chart.chartBgColor || [
      '#ff6385',
      '#36a3eb',
      '#ffcc56',
      '#812ffe',
      '#00e893',
      '#ff9f40',
      '#c9cbcf',
    ];
    const title = chart.title;

    let currentChartType = chart.chartType;
    let indexAxis = null;

    const chartTypeArray = chart.chartType.split('');
    if (chartTypeArray.length > 9) {
      const currentChartTypeArray = chartTypeArray.slice(11);
      currentChartType = currentChartTypeArray.join('');
      indexAxis = 'y';
    }

    return {
      type: currentChartType,
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: bgColors,
            hoverOffset: 2,
          },
        ],
      },
      options: {
        indexAxis: indexAxis,
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: title,
          },
          legend: {
            display: currentChartType === 'bar' || currentChartType === 'line' ? false : true,
          },
        },
      },
    };
  }

  loadCharts() {
    if (this.isChartScriptAvailable()) {
      this.initializeCharts();
    } else {
      this.loadChartScript();
    }
  }

  initializeCharts() {
    this.chartElements.forEach((chart) => {
      const el = typeof chart === 'string' ? document.querySelector(chart) : chart;
      const chartCtx = el.querySelector('canvas').getContext('2d');

      if (!el) return;

      const settings = el.hasAttribute('data-ua-chartjs-options')
        ? JSON.parse(el.getAttribute('data-ua-chartjs-options'))
        : this.defaultChartOptions(chart);

      new Chart(chartCtx, settings);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new ChartJsLoader());
